import React, { useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';


const subjects = [
  'General Inquiry',
  'Account Support',
  'Report a Profile',
  'Billing & Payments',
  'App Feedback',
  'Partnership Inquiry',
  'Other',
];

const contactCards = [
  {
    icon: '📧',
    label: 'Email Us',
    value: 'info@weddyfyp.com',
    sub: 'We respond within 24 hours on working days',
  },
  {
    icon: '📞',
    label: 'Call Us',
    value: '+91 9490023820',
    sub: 'Monday to Saturday · 9 AM – 6 PM IST',
  },
  {
    icon: '📍',
    label: 'Our Office',
    value: 'Old Bowenpally, Hyderabad',
    sub: 'Telangana 500011, India',
  },
  {
    icon: '💬',
    label: 'Social Media',
    value: 'Facebook · Instagram · YouTube',
    sub: 'Reach out through any channel',
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const res = await axios.post('/api/contact', form);
      setStatus({ type: 'success', message: res.data.message });
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      setStatus({ type: 'error', message: err.response?.data?.error || 'Something went wrong. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const inp = {
    width: '100%', padding: '12px 16px', borderRadius: '10px',
    border: '1.5px solid #e5e7eb', fontSize: '15px', color: '#1f2937',
    outline: 'none', background: '#fff', transition: 'border-color 0.2s',
    fontFamily: "'Inter', sans-serif",
  };

  return (
    <div style={{ paddingTop: '70px' }}>
      <Helmet>
        <title>Contact Us - Weddyfyp Matrimony</title>
        <meta name="description" content="Get in touch with the Weddyfyp team. We're here to help with account support, profile queries, partnerships, and any other questions." />
        <link rel="canonical" href="https://weddyfyp.com/contact" />
      </Helmet>

      {/* ── Hero ── */}
      <section style={{ background: 'linear-gradient(150deg, #fdf5f8, #fdf5f8)', padding: '70px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: '680px', margin: '0 auto' }}>
          <div style={{ fontSize: '50px', marginBottom: '18px' }}>📬</div>
          <p style={{ fontSize: '12px', color: '#C2185B', fontWeight: '700', letterSpacing: '2.5px', textTransform: 'uppercase', marginBottom: '14px' }}>GET IN TOUCH</p>
          <h1 style={{ fontSize: 'clamp(30px, 5vw, 48px)', color: '#1c1917', marginBottom: '16px', lineHeight: '1.2' }}>
            We Are Always Ready to Listen
          </h1>
          <p style={{ fontSize: '17px', color: '#6b7280', lineHeight: '1.8' }}>
            Whether you have a question, a concern, or simply want to understand how Weddyfyp can help you — reach out. A real person from our team will get back to you.
          </p>
        </div>
      </section>

      {/* ── Contact Cards ── */}
      <section style={{ padding: '56px 24px 0', background: '#fff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
            {contactCards.map((c, i) => (
              <div key={i} style={{
                padding: '28px 20px', borderRadius: '18px',
                border: '1px solid #f3f4f6', background: '#fff', textAlign: 'center',
                transition: 'box-shadow 0.25s, border-color 0.25s, transform 0.25s',
              }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 10px 30px rgba(194,24,91,0.08)'; e.currentTarget.style.borderColor = '#f8bbd0'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = '#f3f4f6'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{ fontSize: '30px', marginBottom: '12px' }}>{c.icon}</div>
                <div style={{ fontSize: '11px', color: '#9ca3af', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1.2px', marginBottom: '6px' }}>{c.label}</div>
                <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '5px', lineHeight: '1.4' }}>{c.value}</div>
                <div style={{ fontSize: '12px', color: '#9ca3af', lineHeight: '1.5' }}>{c.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Address Banner ── */}
      <section style={{ padding: '32px 24px 0', background: '#fff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ background: '#fce4ec', border: '1px solid #f8bbd0', borderRadius: '16px', padding: '20px 28px', display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '24px' }}>🏢</span>
            <div>
              <p style={{ fontSize: '11px', color: '#C2185B', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1.2px', marginBottom: '4px' }}>Registered Office</p>
              <p style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                A/P P NO 11 &amp; 12, 206, SRI S RESIDENCY, OLD BOWENPALLY, HYDERABAD 500011, Telangana, India
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Message Form ── */}
      <section style={{ padding: '56px 24px 88px', background: '#fff' }}>
        <div style={{ maxWidth: '680px', margin: '0 auto' }}>
          <div style={{
            background: '#fff', borderRadius: '24px', padding: '44px',
            boxShadow: '0 20px 64px rgba(194,24,91,0.07)',
            border: '1px solid rgba(194,24,91,0.09)',
          }}>
            <h2 style={{ fontSize: '26px', color: '#1c1917', marginBottom: '6px' }}>Send a Message</h2>
            <p style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '32px' }}>
              All fields marked * are required. We reply within one business day.
            </p>

            {status && (
              <div style={{
                padding: '14px 18px', borderRadius: '12px', marginBottom: '24px',
                background: status.type === 'success' ? '#f0fdf4' : '#fce4ec',
                border: `1px solid ${status.type === 'success' ? '#bbf7d0' : '#f8bbd0'}`,
                color: status.type === 'success' ? '#15803d' : '#C2185B',
                fontSize: '14px', fontWeight: '500',
                display: 'flex', alignItems: 'flex-start', gap: '10px',
              }}>
                <span style={{ flexShrink: 0 }}>{status.type === 'success' ? '✅' : '❌'}</span>
                {status.message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Full Name *</label>
                  <input name="name" value={form.name} onChange={handleChange} required placeholder="Your full name"
                    style={inp}
                    onFocus={e => e.target.style.borderColor = '#C2185B'}
                    onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Email Address *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="your@email.com"
                    style={inp}
                    onFocus={e => e.target.style.borderColor = '#C2185B'}
                    onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Phone Number</label>
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX"
                    style={inp}
                    onFocus={e => e.target.style.borderColor = '#C2185B'}
                    onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Subject</label>
                  <select name="subject" value={form.subject} onChange={handleChange}
                    style={{ ...inp, cursor: 'pointer' }}
                    onFocus={e => e.target.style.borderColor = '#C2185B'}
                    onBlur={e => e.target.style.borderColor = '#e5e7eb'}>
                    <option value="">Select a subject</option>
                    {subjects.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>

              <div style={{ marginBottom: '28px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Your Message *</label>
                <textarea name="message" value={form.message} onChange={handleChange} required
                  placeholder="Tell us what's on your mind..."
                  rows={5}
                  style={{ ...inp, resize: 'vertical', minHeight: '120px' }}
                  onFocus={e => e.target.style.borderColor = '#C2185B'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>

              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '15px', borderRadius: '50px',
                background: loading ? '#d1d5db' : 'linear-gradient(135deg, #C2185B, #AD1457)',
                color: '#fff', fontWeight: '700', fontSize: '15px',
                border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
                boxShadow: loading ? 'none' : '0 6px 22px rgba(194,24,91,0.28)',
                transition: 'transform 0.2s', fontFamily: "'Inter', sans-serif",
              }}
                onMouseEnter={e => { if (!loading) e.target.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; }}
              >
                {loading ? 'Sending your message…' : 'Send Message →'}
              </button>
            </form>
          </div>
        </div>
      </section>

    </div>
  );
}
